import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

const timeline = [
  {
    name: "NIH funds mLab trial",
    description:
      "The National Institutes of Health awarded a research grant to Columbia University to support the mLabApp study.",
    date: "Aug 2018",
    dateTime: "2018-08",
  },
  {
    name: "FDA IDE Approval",
    description:
      "The US Food & Drug Administration approved the mLabApp as an Investigational Device Exemption.",
    date: "Oct 2018",
    dateTime: "2018-10",
  },
//   {
//     name: "Usability evaluations conclude",
//     description:
//       "Youth Advisory Board and focus groups conclude their evaluation of the mLabApp.",
//     date: "Jul 2019",
//     dateTime: "2019-07",
//   },
  {
    name: "mLabApp enrolls first participants",
    description:
      "The first participants are enrolled in the mLabApp study.",
    date: "Jan 2020",
    dateTime: "2020-01",
  },
  {
    name: "Post-study visits conclude",
    description:
      "The final follow-up visits wrap up.",
    date: "Oct 2023",
    dateTime: "2023-10",
  },
];

export default function Timeline() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="mx-auto mt-8 max-w-7xl px-6 lg:px-8">
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-8 overflow-hidden lg:mx-0 lg:max-w-none lg:grid-cols-4">
        {timeline.map((item) => (
          <div key={item.name}>
            <time
              dateTime={item.dateTime}
              className="flex items-center text-sm font-semibold leading-6 text-blue-600"
            >
              <svg
                viewBox="0 0 4 4"
                className="mr-4 h-1 w-1 flex-none"
                aria-hidden="true"
              >
                <circle cx={2} cy={2} r={2} fill="currentColor" />
              </svg>
              {item.date}
              <div
                className="absolute -ml-2 h-px w-screen -translate-x-full bg-gray-900/10 sm:-ml-4 lg:static lg:-mr-6 lg:ml-8 lg:w-auto lg:flex-auto lg:translate-x-0"
                aria-hidden="true"
              />
            </time>
            <p className="mt-6 text-lg font-semibold leading-8 tracking-tight text-gray-900">
              {item.name}
            </p>
            <p className="mt-1 text-base leading-7 text-gray-600">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
